import { GqlJobState, GqlEmailStatus } from '../../graphql/base-types.graphql';
import { getSummonsOutdated, getEmailHasChanged } from '@startuptools/common/meeting-participants';
import { isNil } from 'lodash-es';

export const emailStatus = ({
  emailState,
  currentEmail,
  summonsEmail,
  emailSummonsId,
  summonsDocId,
  jobState,
}: {
  emailState: GqlEmailStatus | null | undefined;
  currentEmail: string | null | undefined;
  summonsEmail: string | null | undefined;
  emailSummonsId: string | null | undefined;
  summonsDocId: string | null | undefined;
  jobState: GqlJobState | null | undefined;
}) => {
  const emailHasChanged = getEmailHasChanged(currentEmail, summonsEmail);
  const oldSummons = getSummonsOutdated(emailSummonsId, summonsDocId);

  if (!isNil(emailState) && (isNil(jobState) || jobState === GqlJobState.Completed)) {
    return {
      ok: [GqlEmailStatus.Sent, GqlEmailStatus.Delivered].includes(emailState) && !emailHasChanged && !oldSummons,
      emailHasChanged,
      oldSummons,
    };
  } else if (!isNil(jobState)) {
    return {
      ok: jobState === GqlJobState.Completed && !emailHasChanged && !oldSummons,
      emailHasChanged,
      oldSummons,
    };
  }
  return { ok: false, emailHasChanged, oldSummons };
};
